/* Flowcart — customer reviews, backed by Supabase.
   Safe to ship the anon key: Row Level Security restricts anon to reading
   approved rows and inserting pending, unverified ones. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.reviewsReady === 'true') return;
    root.dataset.reviewsReady = 'true';

    // Accept either the project URL or the full REST endpoint — people copy
    // whichever one the dashboard happens to be showing them.
    var base = (root.getAttribute('data-supabase-url') || '')
      .trim()
      .replace(/\/+$/, '')
      .replace(/\/rest\/v1(\/.*)?$/, '');
    var key = root.getAttribute('data-supabase-key');
    var handle = root.getAttribute('data-handle');
    var productId = root.getAttribute('data-product-id');
    if (!base || !key || !handle) return;

    var endpoint = base + '/rest/v1/reviews';

    // Legacy anon keys are JWTs and want an Authorization header too. The newer
    // sb_publishable_* keys are not JWTs — sending them as a Bearer token makes
    // some PostgREST versions reject the request, so only add it for JWTs.
    var headers = { apikey: key };
    if (key.indexOf('eyJ') === 0) {
      headers.Authorization = 'Bearer ' + key;
    }

    var summary = root.querySelector('[data-reviews-summary]');
    var average = root.querySelector('[data-reviews-average]');
    var fill = root.querySelector('[data-reviews-fill]');
    var countEl = root.querySelector('[data-reviews-count]');
    var bars = root.querySelector('[data-reviews-bars]');
    var list = root.querySelector('[data-reviews-list]');
    var state = root.querySelector('[data-reviews-state]');
    var toggle = root.querySelector('[data-reviews-toggle]');
    var form = root.querySelector('[data-reviews-form]');
    var errorEl = root.querySelector('[data-reviews-error]');
    var thanks = root.querySelector('[data-reviews-thanks]');
    var submitBtn = root.querySelector('[data-reviews-submit]');

    var openedAt = Date.now();
    var MIN_SECONDS = 5;

    var MAX_PHOTOS = 3;
    var MAX_EDGE = 1400;          // px — plenty for a product photo
    var JPEG_QUALITY = 0.82;
    var photoInput = root.querySelector('[data-review-photos]');
    var photoPreviews = root.querySelector('[data-photo-previews]');
    var photoNote = root.querySelector('[data-photo-note]');
    var pickedPhotos = [];        // [{ file: Blob, url: objectURL }]
    var publicBase = base + '/storage/v1/object/public/review-photos/';

    function uuid() {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }

    // Phone photos are 4–8MB. Shrinking in the browser keeps uploads quick on
    // mobile data and well under the bucket's 3MB cap.
    function shrink(file) {
      return new Promise(function (resolve) {
        var img = new Image();
        var objUrl = URL.createObjectURL(file);
        img.onload = function () {
          var scale = Math.min(1, MAX_EDGE / Math.max(img.width, img.height));
          var w = Math.round(img.width * scale);
          var h = Math.round(img.height * scale);
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          URL.revokeObjectURL(objUrl);
          canvas.toBlob(function (blob) {
            resolve(blob && blob.size < file.size ? blob : file);
          }, 'image/jpeg', JPEG_QUALITY);
        };
        img.onerror = function () { URL.revokeObjectURL(objUrl); resolve(file); };
        img.src = objUrl;
      });
    }

    function drawPhotoPreviews() {
      if (!photoPreviews) return;
      photoPreviews.hidden = pickedPhotos.length === 0;
      photoPreviews.innerHTML = pickedPhotos.map(function (p, i) {
        return '<div class="photo-picker__item">' +
          '<img src="' + p.url + '" alt="">' +
          '<button type="button" class="photo-picker__remove" data-remove-photo="' + i + '" aria-label="Remove photo ' + (i + 1) + '">&times;</button>' +
          '</div>';
      }).join('');
      if (photoNote) {
        photoNote.hidden = pickedPhotos.length === 0;
        photoNote.textContent = pickedPhotos.length + ' of ' + MAX_PHOTOS + ' photos added';
      }
    }

    if (photoInput) {
      photoInput.addEventListener('change', function () {
        var files = Array.prototype.slice.call(photoInput.files || []);
        photoInput.value = '';  // allow re-picking the same file

        files.forEach(function (file) {
          if (pickedPhotos.length >= MAX_PHOTOS) return;
          if (!/^image\/(jpeg|png|webp)$/.test(file.type)) return;
          shrink(file).then(function (blob) {
            if (pickedPhotos.length >= MAX_PHOTOS) return;
            pickedPhotos.push({ file: blob, url: URL.createObjectURL(blob) });
            drawPhotoPreviews();
          });
        });
      });
    }

    if (photoPreviews) {
      photoPreviews.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-remove-photo]');
        if (!btn) return;
        var i = parseInt(btn.getAttribute('data-remove-photo'), 10);
        URL.revokeObjectURL(pickedPhotos[i].url);
        pickedPhotos.splice(i, 1);
        drawPhotoPreviews();
      });
    }

    // Uploads run before the review row is inserted; the row stores only the
    // generated filenames, never a full URL.
    function uploadPhotos() {
      if (!pickedPhotos.length) return Promise.resolve([]);
      return Promise.all(pickedPhotos.map(function (p) {
        var name = uuid() + '.jpg';
        return fetch(base + '/storage/v1/object/review-photos/' + name, {
          method: 'POST',
          headers: Object.assign({}, headers, { 'Content-Type': p.file.type || 'image/jpeg' }),
          body: p.file
        }).then(function (r) {
          if (!r.ok) throw new Error('Photo upload failed. Try a smaller image.');
          return name;
        });
      }));
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function fmtDate(iso) {
      var d = new Date(iso);
      if (isNaN(d)) return '';
      return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
    }

    // Filenames only ever come from our own bucket, and the pattern check
    // rejects anything that isn't a plain uuid.ext — no path traversal, no
    // pointing at another host.
    var SAFE_NAME = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.(jpg|jpeg|png|webp)$/;

    function photosMarkup(names) {
      if (!Array.isArray(names) || !names.length) return '';
      var safe = names.filter(function (n) { return typeof n === 'string' && SAFE_NAME.test(n); });
      if (!safe.length) return '';
      return '<div class="review__photos">' + safe.map(function (n) {
        var url = publicBase + encodeURIComponent(n);
        return '<a class="review__photo" href="' + url + '" target="_blank" rel="noopener">' +
          '<img src="' + url + '" alt="Customer photo" loading="lazy">' +
          '</a>';
      }).join('') + '</div>';
    }

    function starsMarkup(rating, size) {
      return '<span class="stars stars--' + size + '" role="img" aria-label="' + rating + ' out of 5 stars">' +
        '<span class="stars__track" aria-hidden="true">★★★★★</span>' +
        '<span class="stars__fill" style="width:' + (rating * 20) + '%" aria-hidden="true">★★★★★</span>' +
        '</span>';
    }

    // The stars beside the price are rendered by Liquid from Shopify metafields,
    // which stay empty while reviews live in Supabase. Once we know the real
    // average, swap that "tap to rate" row for the actual score.
    function renderTopRating(avg, count) {
      var promptEl = document.querySelector('[data-rate-prompt]');
      if (!promptEl) return;

      promptEl.innerHTML =
        '<a class="rating rating--lg" href="#reviews">' +
          '<span class="stars stars--lg">' +
            '<span class="stars__track" aria-hidden="true">★★★★★</span>' +
            '<span class="stars__fill" style="width:' + (avg / 5 * 100) + '%" aria-hidden="true">★★★★★</span>' +
          '</span>' +
          '<span class="stars__meta">' + avg +
            ' <span class="stars__count">(' + count + ')</span>' +
          '</span>' +
        '</a>';
      promptEl.classList.add('rate-prompt--scored');
    }

    // ---- Customer photo strip + lightbox --------------------------------
    var gallery = root.querySelector('[data-review-gallery]');
    var galleryGrid = root.querySelector('[data-review-gallery-grid]');
    var lightbox = null;
    var lightboxPhotos = [];
    var lightboxIndex = 0;

    function buildLightbox() {
      if (lightbox) return lightbox;
      lightbox = document.createElement('div');
      lightbox.className = 'photo-lightbox';
      lightbox.hidden = true;
      lightbox.innerHTML =
        '<div class="photo-lightbox__overlay" data-lb-close></div>' +
        '<button class="photo-lightbox__close" type="button" data-lb-close aria-label="Close">&times;</button>' +
        '<button class="photo-lightbox__nav photo-lightbox__nav--prev" type="button" data-lb-prev aria-label="Previous photo">‹</button>' +
        '<img class="photo-lightbox__img" alt="Customer photo" data-lb-img>' +
        '<button class="photo-lightbox__nav photo-lightbox__nav--next" type="button" data-lb-next aria-label="Next photo">›</button>' +
        '<span class="photo-lightbox__count" data-lb-count></span>';
      document.body.appendChild(lightbox);

      lightbox.querySelectorAll('[data-lb-close]').forEach(function (el) {
        el.addEventListener('click', closeLightbox);
      });
      lightbox.querySelector('[data-lb-prev]').addEventListener('click', function () { stepLightbox(-1); });
      lightbox.querySelector('[data-lb-next]').addEventListener('click', function () { stepLightbox(1); });
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') stepLightbox(-1);
        if (e.key === 'ArrowRight') stepLightbox(1);
      });
      return lightbox;
    }

    function paintLightbox() {
      var lb = buildLightbox();
      lb.querySelector('[data-lb-img]').src = publicBase + encodeURIComponent(lightboxPhotos[lightboxIndex]);
      lb.querySelector('[data-lb-count]').textContent = (lightboxIndex + 1) + ' / ' + lightboxPhotos.length;
      var multiple = lightboxPhotos.length > 1;
      lb.querySelector('[data-lb-prev]').hidden = !multiple;
      lb.querySelector('[data-lb-next]').hidden = !multiple;
    }

    function openLightbox(photos, index) {
      lightboxPhotos = photos;
      lightboxIndex = index;
      var lb = buildLightbox();
      paintLightbox();
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function stepLightbox(delta) {
      lightboxIndex = (lightboxIndex + delta + lightboxPhotos.length) % lightboxPhotos.length;
      paintLightbox();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    var TILES = 5;   // one large + four small, like a photo wall

    function renderGallery(rows) {
      if (!gallery || !galleryGrid) return;

      var photos = [];
      rows.forEach(function (r) {
        if (!Array.isArray(r.photos)) return;
        r.photos.forEach(function (n) {
          if (typeof n === 'string' && SAFE_NAME.test(n)) photos.push(n);
        });
      });

      if (!photos.length) { gallery.hidden = true; galleryGrid.innerHTML = ''; return; }

      var shown = photos.slice(0, TILES);
      var extra = photos.length - shown.length;

      galleryGrid.innerHTML = shown.map(function (n, i) {
        var isLast = i === shown.length - 1;
        var overlay = (isLast && extra > 0) ? '<span class="review-gallery__more">+' + extra + '</span>' : '';
        return '<button type="button" class="review-gallery__item" data-gallery-index="' + i + '" aria-label="Open customer photo ' + (i + 1) + '">' +
            '<img src="' + publicBase + encodeURIComponent(n) + '" alt="" loading="lazy">' + overlay +
          '</button>';
      }).join('');

      galleryGrid.onclick = function (e) {
        var btn = e.target.closest('[data-gallery-index]');
        if (!btn) return;
        openLightbox(photos, parseInt(btn.getAttribute('data-gallery-index'), 10) || 0);
      };

      gallery.hidden = false;
    }

    function render(rows) {
      if (!rows || !rows.length) {
        state.textContent = 'No reviews yet — be the first to review this product.';
        state.hidden = false;
        summary.hidden = true;
        list.innerHTML = '';
        renderGallery([]);
        return;
      }

      var breakdown = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      var total = 0;
      rows.forEach(function (r) {
        total += r.rating;
        if (breakdown[r.rating] != null) breakdown[r.rating]++;
      });
      var avg = Math.round(total / rows.length * 10) / 10;

      renderGallery(rows);
      renderTopRating(avg, rows.length);

      state.hidden = true;
      summary.hidden = false;
      average.textContent = avg;
      fill.style.width = (avg / 5 * 100) + '%';
      countEl.textContent = 'Based on ' + rows.length + ' review' + (rows.length === 1 ? '' : 's');

      bars.innerHTML = [5, 4, 3, 2, 1].map(function (star) {
        var n = breakdown[star];
        var pct = Math.round(n / rows.length * 100);
        return '<div class="reviews__bar-row">' +
          '<span class="reviews__bar-label">' + star + '★</span>' +
          '<span class="reviews__bar"><span class="reviews__bar-fill" style="width:' + pct + '%"></span></span>' +
          '<span class="reviews__bar-count">' + n + '</span>' +
          '</div>';
      }).join('');

      list.innerHTML = rows.map(function (r) {
        return '<li class="review">' +
          '<div class="review__head">' +
            '<span class="review__avatar" aria-hidden="true">' + esc(r.author.charAt(0)) + '</span>' +
            '<div class="review__who">' +
              '<span class="review__name">' + esc(r.author) +
                (r.city ? '<span class="review__city">, ' + esc(r.city) + '</span>' : '') +
              '</span>' +
              (r.verified ? '<span class="review__verified">✓ Verified buyer</span>' : '') +
            '</div>' +
            '<time class="review__date">' + esc(fmtDate(r.created_at)) + '</time>' +
          '</div>' +
          starsMarkup(r.rating, 'sm') +
          (r.title ? '<strong class="review__title">' + esc(r.title) + '</strong>' : '') +
          '<p class="review__body">' + esc(r.body) + '</p>' +
          photosMarkup(r.photos) +
        '</li>';
      }).join('');
    }

    function load() {
      var q = endpoint +
        '?select=author,city,rating,title,body,verified,created_at,photos' +
        '&product_handle=eq.' + encodeURIComponent(handle) +
        '&status=eq.approved' +
        '&order=created_at.desc&limit=100';

      fetch(q, { headers: headers })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error(r.status)); })
        .then(render)
        .catch(function () {
          state.textContent = 'Reviews are unavailable right now.';
          state.hidden = false;
        });
    }

    function openForm() {
      if (!form) return;
      form.hidden = false;
      if (toggle) toggle.hidden = true;
      openedAt = Date.now();
    }

    if (toggle && form) {
      toggle.addEventListener('click', function () {
        openForm();
        var firstStar = form.querySelector('.star-input label');
        if (firstStar) firstStar.focus();
      });
    }

    // "Tap to rate" stars beside the price: preselect the rating, open the
    // form, scroll to it. Wired here rather than in the snippet so it only
    // works when a backend is actually configured.
    var prompt = document.querySelector('[data-rate-prompt]');
    if (prompt && form) {
      prompt.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-rate]');
        if (!btn) return;

        var value = btn.getAttribute('data-rate');
        var radio = form.querySelector('input[name="rating"][value="' + value + '"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        openForm();

        // offset for the sticky header so the heading isn't hidden under it
        var header = document.querySelector('.site-header');
        var offset = (header ? header.offsetHeight : 0) + 16;
        var top = form.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
          top: top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });

        var name = form.querySelector('input[name="author"]');
        if (name) setTimeout(function () { name.focus({ preventScroll: true }); }, 400);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        errorEl.hidden = true;

        var fd = new FormData(form);

        // Honeypot: hidden from people, filled by bots. Pretend success.
        if ((fd.get('website') || '').trim() !== '') {
          form.hidden = true;
          thanks.hidden = false;
          return;
        }

        var payload = {
          product_handle: handle,
          product_id: productId,
          author: (fd.get('author') || '').trim(),
          email: (fd.get('email') || '').trim().toLowerCase() || null,
          city: (fd.get('city') || '').trim() || null,
          title: (fd.get('title') || '').trim() || null,
          body: (fd.get('body') || '').trim(),
          order_number: (fd.get('order_number') || '').trim() || null,
          rating: parseInt(fd.get('rating'), 10) || 0
        };

        if (!payload.rating) return fail('Please choose a star rating.');
        if (!payload.author) return fail('Please enter your name.');
        // Optional, but if given it must be plausible — the database enforces
        // the same rule, this just gives a friendlier message.
        if (payload.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(payload.email)) {
          return fail('That email address does not look right. Leave it blank if you prefer.');
        }
        if (payload.body.length < 10) return fail('Please write at least a sentence.');
        if (payload.body.length > 2000) return fail('Your review is too long.');
        if ((Date.now() - openedAt) / 1000 < MIN_SECONDS) {
          return fail('Please take a moment to write your review.');
        }

        submitBtn.disabled = true;
        submitBtn.textContent = pickedPhotos.length ? 'Uploading photos…' : 'Sending…';

        uploadPhotos()
          .then(function (names) {
            payload.photos = names;
            submitBtn.textContent = 'Sending…';
            return fetch(endpoint, {
              method: 'POST',
              headers: Object.assign({}, headers, {
                'Content-Type': 'application/json',
                Prefer: 'return=minimal'
              }),
              body: JSON.stringify(payload)
            });
          })
          .then(function (r) {
            if (r.ok) return null;
            return r.json().then(function (j) {
              throw new Error(j.message || 'Could not send your review.');
            }, function () {
              throw new Error('Could not send your review.');
            });
          })
          .then(function () {
            form.hidden = true;
            thanks.hidden = false;
          })
          .catch(function (err) { fail(err.message); })
          .then(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit review';
          });

        function fail(msg) {
          errorEl.textContent = msg;
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit review';
        }
      });
    }

    load();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
